// extracted by mini-css-extract-plugin
module.exports = {"slotSkeleton":"SlotSelect_slotSkeleton__TQfzW"};